module.exports = __webpack_public_path__ + "img/align-center.b8e2d739.svg";